// noinspection JSUnusedGlobalSymbols

import * as Apollo from '@apollo/client';

import { gql } from '@apollo/client';
import type * as Types from '../../__generated__/types';

const defaultOptions = {} as const;
export type ListCompanyEmailDomainsQueryVariables = Types.Exact<{
  pageNumber: Types.InputMaybe<Types.Scalars['Int']['input']>;
  pageSize: Types.InputMaybe<Types.Scalars['Int']['input']>;
  enabled: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;

export type ListCompanyEmailDomainsQuery = { __typename?: 'Query' } & {
  listCompanyEmailDomains: { __typename?: 'ListCompanyEmailDomains' } & Pick<
    Types.ListCompanyEmailDomains,
    'totalCount'
  > & {
      items: Array<
        { __typename?: 'CompanyEmailDomain' } & Pick<
          Types.CompanyEmailDomain,
          'id' | 'enabled' | 'createdAt' | 'updatedAt' | 'disableExternalAccount' | 'awsSesPolicyApplied'
        > & { name: Types.CompanyEmailDomain['id'] }
      >;
    };
};

export const ListCompanyEmailDomainsDocument = /*#__PURE__*/ gql`
    query listCompanyEmailDomains($pageNumber: Int, $pageSize: Int, $enabled: Boolean) {
  listCompanyEmailDomains(
    filter: {pageNumber: $pageNumber, pageSize: $pageSize, enabled: $enabled}
  ) {
    items {
      id
      name: id
      enabled
      createdAt
      updatedAt
      disableExternalAccount
      awsSesPolicyApplied
    }
    totalCount
  }
}
    `;

/**
 * __useListCompanyEmailDomainsQuery__
 *
 * To run a query within a React component, call `useListCompanyEmailDomainsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCompanyEmailDomainsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCompanyEmailDomainsQuery({
 *   variables: {
 *      pageNumber: // value for 'pageNumber'
 *      pageSize: // value for 'pageSize'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useListCompanyEmailDomainsQuery(
  baseOptions?: Apollo.QueryHookOptions<ListCompanyEmailDomainsQuery, ListCompanyEmailDomainsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListCompanyEmailDomainsQuery, ListCompanyEmailDomainsQueryVariables>(
    ListCompanyEmailDomainsDocument,
    options,
  );
}
export function useListCompanyEmailDomainsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListCompanyEmailDomainsQuery, ListCompanyEmailDomainsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListCompanyEmailDomainsQuery, ListCompanyEmailDomainsQueryVariables>(
    ListCompanyEmailDomainsDocument,
    options,
  );
}
// @ts-expect-error
export function useListCompanyEmailDomainsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ListCompanyEmailDomainsQuery, ListCompanyEmailDomainsQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListCompanyEmailDomainsQuery, ListCompanyEmailDomainsQueryVariables>;
export function useListCompanyEmailDomainsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListCompanyEmailDomainsQuery, ListCompanyEmailDomainsQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListCompanyEmailDomainsQuery | undefined, ListCompanyEmailDomainsQueryVariables>;
export function useListCompanyEmailDomainsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListCompanyEmailDomainsQuery, ListCompanyEmailDomainsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListCompanyEmailDomainsQuery, ListCompanyEmailDomainsQueryVariables>(
    ListCompanyEmailDomainsDocument,
    options,
  );
}
export type ListCompanyEmailDomainsQueryHookResult = ReturnType<typeof useListCompanyEmailDomainsQuery>;
export type ListCompanyEmailDomainsLazyQueryHookResult = ReturnType<typeof useListCompanyEmailDomainsLazyQuery>;
export type ListCompanyEmailDomainsSuspenseQueryHookResult = ReturnType<typeof useListCompanyEmailDomainsSuspenseQuery>;
